import React, { useState, useEffect } from 'react';
// import { useTranslation } from "react-i18next";
import campaignPolls from 'js/library/utils/API/campaignPolls';
import { getLastUserInfo, getUrlVariables } from 'js/library/utils/helpers';
import { Grid, CircularProgress, Button, Typography } from '@mui/material';

import refuseIcon from 'styles/assets/icons/icon-refuse.svg';
import loadingItem from 'styles/assets/icons/loading-item.gif';
import checkIcon from 'styles/assets/icons/icon-check.svg';
import approved from 'styles/assets/icons/icon-ok.png';
import rejected from 'styles/assets/icons/icon-rejected.png';
import approvalPhoto from 'js/library/utils/API/approvalPhoto';
import cfac22 from 'js/library/utils/cfac22';

export function CampaignImagePollsApproval() {
  // const { t } = useTranslation();
  const userInfo = getLastUserInfo();
  const urlVars = getUrlVariables();
  const [imagesArray, setImagesArray] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userInfo.admin) {
      campaignPolls(userInfo.uId, urlVars.campaignId).then((cp) => {
        setImagesArray(
          cp.response.filter((e) => {
            return !e.hasOwnProperty('approval') && e.hasOwnProperty('photoPath');
          })
        );
        setLoading(false);
      });
    }
  });

  const approvalImage = (approval, id) => {
    const approvalIcons = document.getElementById(id);
    approvalIcons.innerHTML = `<img src=${loadingItem} alt="loadingItem" style="max-height: 40px;" />`;

    approvalPhoto(urlVars.campaignId, id, approval)
      .then((resp) => {
        if (resp.success) {
          if (approval) {
            approvalIcons.innerHTML = `<img src=${approved} alt="approvation" style="max-height: 40px;" />`;
          } else {
            approvalIcons.innerHTML = `<img src=${rejected} alt="approvation" style="max-height: 40px;" />`;
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return userInfo.admin ? (
    <Grid container spacing={2}>
      {loading ? (
        <CircularProgress />
      ) : imagesArray.length === 0 ? (
        <Grid size={{ xs: 12 }}>
          <Typography variant="h6" color="primary" style={{ textAlign: 'center', padding: 50 }}>
            NÃO EXISTEM IMAGENS PENDENTES DE APROVAÇÃO
          </Typography>
        </Grid>
      ) : (
        imagesArray.map((item) => {
          return (
            <Grid size={{ xs: 12, sm: 6 }} key={item.id} style={{ textAlign: 'center' }}>
              <img
                src={cfac22('STORAGE_URL') + encodeURIComponent(item.photoPath) + '?alt=media'}
                style={{ maxHeight: 200 }}
                alt={item.id}
              />
              <Typography variant="body1" color="primary">
                {item.photoName}
              </Typography>
              <div
                id={item.id}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  width: '100%',
                }}
              >
                <Button
                  variant="text"
                  style={{ backgroundColor: 'green', width: '30%' }}
                  onClick={() => approvalImage(true, item.id)}
                >
                  <img src={checkIcon} alt="check" style={{ maxHeight: 40 }} />
                </Button>
                <span style={{ width: 10 }}></span>
                <Button
                  variant="text"
                  style={{ backgroundColor: 'red', width: '30%' }}
                  onClick={() => approvalImage(false, item.id)}
                >
                  <img src={refuseIcon} alt="check" style={{ maxHeight: 40 }} />
                </Button>
              </div>
            </Grid>
          );
        })
      )}
    </Grid>
  ) : (
    <>Você não possui acesso á essa área.</>
  );
}
